import { getAppData } from '../../lib/api/common';
import {
	getAllServices,
	getServiceByUri
} from '../../lib/api/services';
import { getLatestNewsBlockItems } from '../../lib/api/news'

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'

import ServiceDefault from '../../components/service/default'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";

export type ServiceProps = {
	service: any // service entry
	services: any // services landing page
	app: any
	dynamicData: any
}



export async function getStaticPaths() {

	// Only the first page is statically generated
	const data: any = await getAllServices();

	const paths = data.entries && data.entries.length > 0 ? data.entries.map((entry: any) => {
		return {
			params: { uri: entry.uri.split('/') },
		}
	}) : []

	return {
		paths,
		fallback: 'blocking',
	};
}


export async function getStaticProps(context: any) {

	const uri: Array<string> = context.params && context.params.uri
	const uriString = uri.join('/')

	const app: any = await getAppData();
	const data: any = await getServiceByUri(
		`services/${uriString}`,
		context.preview ? context.previewData?.token : undefined
	);

	if ( !data.service ) {
		return {
			notFound: true,
			revalidate: revalidateSeconds()
		}
	}

	// Check for dynamic content blocks
	const latestNewsBlocks = data.service.pageBuilder?.filter((block: any) => block.typeHandle === 'latestNews')

	const siteHandle = data.service.siteHandle ?? '*';
	// Get latest news if block is present
	const latestNews = latestNewsBlocks && latestNewsBlocks.length > 0 ? await getLatestNewsBlockItems( siteHandle ) : null

	return {
		props: {
			app: app ? app : null,
			service: data.service ? data.service : null, // Current page
			services: data.services ? data.services : null, // Top level services page. Used for navigation
			dynamicData: {
				news: latestNews?.news ? latestNews.news : null,
			}
		},
		revalidate: revalidateSeconds()
	};
}



export default function Service(props: ServiceProps) {

	const { service, services, app, dynamicData } = props

	// Build breadcrumbs
	let breadcrumbs: any = [
		{
			id: services.id,
			title: services.title,
			uri: services.uri
		}
	]

	if (service) {
		if (service.ancestors) {
			service.ancestors.forEach((link: any) => breadcrumbs.push(link))
		}
		breadcrumbs.push({
			id: service.id,
			title: service.title,
			uri: null
		})
	}

	return (
		<>
			<SeoMaticHead seo={service.seo} />
			<Layout
				key={service.id}
				appData={app}
				subHeader={breadcrumbs}
			>
				<ServiceDefault service={service} dynamicData={dynamicData} />
			</Layout>
		</>
	)
}
